<div class="header">
    <h3>Name change</h3>
    <i
       (click)="action(false)"
       class="close-icon icon-cross_16px"></i>
</div>
<div class="content-modal">
    <span>{{ beginningOfText }}</span>
    <a href="mailto:{{ email }}"
        target="_blank">
        {{ email }}
    </a>
    <span>{{ endOfText }}</span>
</div>
<div class="controls">
    <button
            appTrackClickButton
            type="button"
            class="button primary"
            (click)="action(false)">{{ buttonsTitle.close }}</button>
</div>

